
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book-an-appointment",
      function () {
        return require("private-next-pages/book-an-appointment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/book-an-appointment"])
      });
    }
  